import React from 'react';

// Constante pour le nom de l'application
export const APP_NAME = "SimulReno";

interface LogoProps {
  className?: string;
}

const Logo: React.FC<LogoProps> = ({ className = "" }) => {
  return (
    <span className={`text-white font-semibold ${className}`}>
      {APP_NAME}
    </span>
  );
};

export default Logo;